import {client as clientAxios} from "@src/library/axios.library";
import {AxiosResponse} from "axios";
import {PaginationDataType} from "@src/types/global.types";
import {ProductFilterType, ProductType} from "@product/types/product.types";

export const getProductCollection = async (filter: ProductFilterType): Promise<PaginationDataType<ProductType>> => {
    const {data} = await clientAxios.post<ProductFilterType, AxiosResponse<PaginationDataType<ProductType>>>('/api/v1/product', filter);
    return data;
}
